<!-- <p>dashboard-pie-chart works!</p> -->

<div *ngIf="!creating && !publicPanelData[panelData.id]" class="spinner alignColumn">
    <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/circle-lines.gif">
</div>

<div *ngIf="creating && !panelData" class="pie-panel alignRow alignColumn">
    <ejs-accumulationchart id="pie_example" style="height: 100%; width: 100%;" [title]="'Example Folder - Consumption'"
        [legendSettings]="pieChartLegendSettings" [enableAnimation]="true" [enableBorderOnMouseMove]="true"
        [enableSmartLabels]="true" [tooltip]="tooltip">
        <e-accumulation-series-collection>
            <e-accumulation-series name='Datapoint' xName='name' yName='usage' [animation]="{enable: false}"
                [dataLabel]="pieChartLabels" [dataSource]="examplePieChartData">
            </e-accumulation-series>
        </e-accumulation-series-collection>
    </ejs-accumulationchart>
</div>

<div *ngIf="creating && panelData" class="pie-panel alignRow alignColumn">
    <div class="text-panel-title alignRow">
        <span>{{(panelData.title || panelData.nodeData.Name)}} </span>
        <mat-icon [matMenuTriggerFor]="titleMenu" [matMenuTriggerData]="{panelData: panelData}">edit</mat-icon>
    </div>
    <!-- [title]="'Example Folder - Consumption'"  -->
    <ejs-accumulationchart id="pie_{{panelData.id}}" style="height: 100%; width: 100%;"
        [legendSettings]="pieChartLegendSettings" [enableAnimation]="true" [enableBorderOnMouseMove]="true"
        [enableSmartLabels]="true" [tooltip]="tooltip" (textRender)="textRender($event)">
        <e-accumulation-series-collection>
            <e-accumulation-series name='Datapoint' xName='name' yName='usage' [animation]="{enable: false}"
                [dataLabel]="pieChartLabels" [dataSource]="nodePieChartData">
            </e-accumulation-series>
        </e-accumulation-series-collection>
    </ejs-accumulationchart>
</div>

<div *ngIf="!creating && publicPanelData[panelData.id]" class="pie-panel alignRow alignColumn">
    <div class="text-panel-title alignRow">
        <span>{{!publicPanelData[panelData.id] ? 'Loading...' : panelData.title || panelData.nodeData.Name}}</span>
    </div>
    <ejs-accumulationchart id="pie_{{panelData.id}}" style="height: 100%; width: 100%;"
        [legendSettings]="pieChartLegendSettings" [enableAnimation]="true" [enableBorderOnMouseMove]="true"
        [enableSmartLabels]="true" [tooltip]="tooltip" (textRender)="textRender($event)">
        <e-accumulation-series-collection>
            <e-accumulation-series name='Datapoint' xName='name' yName='usage' [animation]="{enable: false}"
                [dataLabel]="pieChartLabels" [dataSource]="publicPanelData[panelData.id].pieData ?? []">
            </e-accumulation-series>
        </e-accumulation-series-collection>
    </ejs-accumulationchart>
</div>